import styled, { css } from 'styled-components';

export const CheckBoxWrapper = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  user-select: none;
  min-height: 20px;
`;
export const CheckPrice = styled.span`
  margin-left: auto;
  font-size: 1rem;
  font-weight: 600;
`;
export const CheckLabel = styled.label<{ readonly isRadio?: boolean; readonly viewOnly?: boolean }>`
  font-size: 1.2rem;
  position: relative;
  padding-left: ${({ viewOnly }) => (viewOnly ? '0' : '30px')};
  cursor: ${({ viewOnly }) => (viewOnly ? 'auto' : 'pointer')};
  line-height: 1;
  font-weight: 400;
  display: flex;
  align-items: center;
  & > span {
    position: absolute !important;
    left: 4px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    opacity: 0;
    visibility: hidden;
    transition: 0.3s ease opacity;
    ${({ viewOnly }) =>
      viewOnly &&
      css`
        display: none;
      `}
  }
  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    border: 1px solid ${({ theme }) => theme.colors.lightenPurple};
    border-radius: ${({ isRadio }) => (isRadio ? '50%' : '4px')};
    transition: 0.3s ease background-color, 0.3s ease border-color;
    ${({ viewOnly }) =>
      viewOnly &&
      css`
        display: none;
      `}
  }
  &::after {
    transition: 0.3s ease opacity;
    opacity: 0;
    border: none;
    width: ${({ isRadio }) => (isRadio ? '12px' : '20px')};
    height: ${({ isRadio }) => (isRadio ? '12px' : '20px')};
    background-color: ${({ isRadio, theme }) => (isRadio ? theme.colors.brandColor : 'inherit')};
    ${({ isRadio }) =>
      isRadio &&
      css`
        left: 4px;
      `}
  }
  &:hover {
    &::before {
      border-color: ${({ theme }) => theme.colors.brandColor};
      ${({ isRadio }) =>
        isRadio &&
        css`
          background-color: inherit;
        `}
    }
  }
`;
export const CheckInput = styled.input`
  visibility: hidden;
  width: 0;
  height: 0;
  position: absolute;
  z-index: -100;
  &:checked {
    & + ${CheckLabel} {
      &::before {
        border-color: ${({ theme }) => theme.colors.brandColor};
      }
      &::after {
        opacity: 1;
      }
      & > span {
        opacity: 1;
        visibility: visible;
      }
    }
  }
`;
